//#region redux
import { qualifiedSharedDividendsReportSnoozed } from "store/actions/qualifiedSharedDividendsActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";

function useQualifiedShareDividendSnoozeAction(id: number | string, markAsDone: (id: number | string) => void) {
  const dispatch = useDispatch();

  const onSnoozeQualifiedShareDividendSuccess = () => {
    dispatch(qualifiedSharedDividendsReportSnoozed(id.toString()));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.QualifiedShareDividend,
    onSnoozeQualifiedShareDividendSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.QualifiedShareDividends.K10Form)
  );

  return snoozeAction;
}

export default useQualifiedShareDividendSnoozeAction;
